"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100vw',
    marginTop: '-5px'
  },
  rowBase: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: '0 4vw',
    maxWidth: '1000px'
  },
  row2: {
    '@media (min-width: 1000px)': {
      justifyContent: 'center'
    }
  },
  row3: {
    textAlign: 'left',
    lineHeight: '1.2',
    paddingTop: '20px'
  },
  headerText: {
    fontSize: '2rem',
    fontWeight: '400',
    lineHeight: '1.1',
    '@media (max-width: 767px)': {
      fontSize: '2rem',
      textAlign: 'left'
    }
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px 10px',
    borderRadius: '75px',
    width: '375px',
    minHeight: '85px',
    WebkitTransition: '.5s all',
    transition: '.5s all',
    whiteSpace: 'nowrap',
    border: 'none',
    fontSize: '1.8rem',
    padding: '0',
    '@media (max-width: 767px)': {
      fontSize: '1.4rem',
      width: '90vw',
      minHeight: '65px',
      fontWeight: 'bold'
    }
  },
  hover: {
    cursor: 'pointer',
    WebkitBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
    MozBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
    boxShadow: '5px 40px -10px rgba(0,0,0,0.57)',
    transition: 'all 0.7s ease',
    fontSize: '1.6rem'
  },
  lightBlue: {
    color: 'white',
    backgroundColor: '#64c3e4'
  },
  blue: {
    color: 'white',
    backgroundColor: '#2670c5'
  },
  articleHeading: {
    minWidth: '100%',
    fontSize: '1.6rem',
    paddingBottom: '20px',
    paddingTop: '40px',
    fontWeight: 'bold'
  },
  articleContent: {
    fontWeight: '400',
    fontSize: '1.2rem'
  },
  contentItem: {
    marginBottom: '20px'
  }
};
exports.default = _default;

//# sourceMappingURL=DebtOptin.css.js.map